import React, { useState } from "react";
import Header from "./components/Header";
import Navigation from "./Navigation";
import Footer from "./components/Footer";
import { BrowserRouter as Router } from "react-router-dom";
import { menuList } from "./utils";
import { Menu } from "./models/menu";

const Layout = () => {
    const [menu, setMenu] = useState<Menu[]>(menuList);
    const menuChange = (index: number) => {
        const updatedMenu: Menu[] = menu.map((el, key)=> {
            return {...el, cliqued: key === index ? true : false}
        })
        setMenu(updatedMenu);
    }


    return(
        <Router>
            <div className="layout">
                <Header menu={menu} menuChange={menuChange} />
                <div className="container grow-1 width-100p">
                    <Navigation start={menuChange}/>
                </div>
                <Footer/>
            </div>
        </Router>
    )
}

export default Layout;